import "normalize.css/normalize.css";

import "./global/global.css";
import "./global/colors/primitives.css";
import "./global/colors/tokens.css";
import "./global/colors/themes.css";
 
// import "./global/typography/fonts.css";
import "./global/typography/typography.css";
import "./global/radius/radius.css";
import "./global/spacing/spacing.css";
import "./global/tables/tables.css";
import "./global/layout/layout.css";
import "./global/inputs/inputs.css";

import "./patterns/breadcrumbs/breadcrumbs.css";
import "./patterns/button/button.css";
import "./patterns/card/card.css";
import "./patterns/podcast/podcast.css";
import "./patterns/grid/grid.css";
import "./patterns/header/header.css";
import "./patterns/footer/footer.css";
import "./patterns/wrapper/wrapper.css";
import "./patterns/navtree/navtree.css";
import "./patterns/wrapper/wrapper.css";
import "./patterns/navtree/navtree.css";
import "./patterns/sliderinput/sliderinput.css";
import "./patterns/tabs/tabs.css";
import "./patterns/highcostcalc/highcostcalc.css";
import "./patterns/accordion/accordion.css";
import "./patterns/richtext/richtext.css";
import "./patterns/hero/hero.css";
import "./patterns/section/section.css";
import "./patterns/teaser-card/teaser-card.css";
import "./patterns/article-card/article-card.css";
import "./patterns/tag/tag.css";
import "./patterns/quote/quote.css";
import "./patterns/image/image.css";
import "./patterns/fritidsfaqblock/fritidsfaqblock.css";
import "./patterns/logo/logo.css";
import "./patterns/form/form.css";
import "./patterns/form-epi/form-epi.css";
import "./patterns/pharmaceutical-list-page/pharmaceutical-list-page.css";
import "./patterns/main/main.css";
import "./patterns/linklist/linklist.css"
import "./patterns/search-field/search-field.css";
import "./patterns/facet/facet.css";
import "./patterns/toggle/toggle.css";
import "./patterns/article-list/article-list.css";
import "./patterns/pagination/pagination.css"
import "./patterns/context-menu/context-menu.css"
import "./patterns/operationalstatus/operationalstatus.css"
import "./patterns/modal/modal.css"
import "./patterns/vma/vma.css";
import "./patterns/knowledgepage/knowledgepage.css";
import "./patterns/cookiebanner/cookiebanner.css";
import "./patterns/script-block/script-block.css";
import "./patterns/news-block/news-block.css";
import "./patterns/skiplink/skiplink.css";
import "./patterns/job-application/job-application.css";
import "./patterns/logout/logout.css";
import "./patterns/event/event.css";
import "./patterns/linkbuttonsblock/linkbuttonsblock.css";
import "./patterns/loginlink/loginlink.css";
import "./patterns/document-list/document-list.css";
import "./patterns/details/details.css";
import "./patterns/notfound/notfound.css";
import "./patterns/portrait-gallery/portrait-gallery.css";
import "./patterns/spinner/spinner.css";
import "./patterns/fritidskort-search/fritidskort-search.css";

import "./patterns/input/input.css";
import "./global/colors/themes.css";


import "./components/ehm-icon/ehm-icon";
import "./components/searchbox/searchbox";
import "./components/ehm-drawer/ehm-drawer";
import "./components/ehm-navtree/ehm-navtree";
import "./components/ehm-highcostcalc/ehm-highcostcalc";
import "./components/ehm-search/ehm-search";
import "./components/ehm-carousel/carousel";
import "./components/ehm-reveal/ehm-reveal";
import "./components/ehm-forminput/ehm-forminput";
import "./components/ehm-tab/ehm-tab";
import "./components/ehm-video/ehm-video";
import "./util/fritids-form";
import "./util/fritidskort-search";
import "./util/map";
import "./util/cookiebanner";
import "./components/ehm-context-nav/context-nav";
import "./components/ehm-header/header.ts";
import "./components/ehm-pattern/ehm-pattern";
import "./components/ehm-filter/filter";
import "./components/ehm-filter/filter-tabs";
import "./components/ehm-filter/filter-facets";
import "./components/ehm-filter/filter-active";
import "./components/ehm-filter/filter-results";
import "./components/ehm-filter/filter-searchfield";
import "./components/ehm-pagination/pagination";
import "./components/ehm-context-menu/context-menu";
import "./components/ehm-suggest/suggest";
import "./components/ehm-audioplayer/ehm-audioplayer";
import "./components/ehm-skip-to-content/skip-to-content";
import "./components/ehm-audioplayer/ehm-audioplayer";
import "./components/ehm-details-wrapper/details-wrapper";
import "./components/ehm-breadcrumbs/breadcrumbs";

import "./_docs/styles/styleguide.css";

import { listen } from "quicklink";

window.addEventListener("load", () => {
  listen();
});
